import { useEffect, useState, useRef } from 'react';
import {
    addInterviewRound,
    deleteInterview,
    getInterviewRound,
    getJobsInformation,
    getStageRound,
    insertInterviewRound,
    deleteScreening
} from '../../service/RecruiterApi';
import { Typeahead } from 'react-bootstrap-typeahead';
import './Customise-hiring-process.css';
import { Navigate } from 'react-router-dom';

function CustomHiringProcess() {
    let defaultData = {
        round_id: '',
        stage_id: '',
        assessment: [],
        job_id: '',
        interview_round_name: '',
    };

    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    const [remove, setRemove] = useState('');
    const ref = useRef(null);
    let [newRound, setNewRound] = useState([]);
    const [isShown, setIsShown] = useState(false);
    const [flag, setFlag] = useState(false);
    const [selectedAssesment, setSelectedAssesment] = useState([]);
    const [preliminary, setPreliminary] = useState(true);
    const [expques, setexpques] = useState('');
    const [screeningRound, setScreeningRound] = useState([])
    const screeningOptions = ['Preliminary', 'Aptitude Test', 'Technical', 'Coding Challenge']
    const [isHover, setIsHover] = useState(false)

    useEffect(() => {
        getCustomRounds();
    }, []);

    const getCustomRounds = async () => {
        let data = {
            job_id: params.id,
        };
        let resp = await getJobsInformation({ jobID: params.id });

        var value = resp.data.data[0].experience;
        // if(value=="Fresher")
        setexpques(value);

        getStageRound(data).then((res) => {
            if (res.data.statusCode == 200) {
                setNewRound(res.data.data);
                const roundMapping = {
                    1: 'Preliminary',
                    2: 'Aptitude Test',
                    3: 'Technical',
                    4: 'Coding Challenge'
                };
                const screeningRounds = res.data.screenData.map(id => {
                    return { id: id.id, label: roundMapping[id.screening_round_id] };
                });
                const arrRounds = screeningRounds.filter(id => id.label !== "Preliminary")
                setScreeningRound(arrRounds);
                setFlag(!flag);
            }
        });
    };

    let removePreliminary = () => {
        try {
        } catch (e) {
            throw e;
        }
    };
    let saveAssessment = (i, id) => {
        try {
            let obj = newRound[i];
            obj['assessment_id'] = selectedAssesment;

            setSelectedAssesment([]);
        } catch (error) {
            throw error;
        }
    };

    let addRound = () => {
        try {
            let interviewRound = newRound;
            let data = {
                interview_round_name: '',
                stage_id: 3,
                job_id: params.id,
                assessment_id: [],
            };
            interviewRound.push(data);
            setNewRound(interviewRound);
            setFlag(!flag);
        } catch (e) {
            throw e;
        }
    };



    let handleEnterbutton = (i) => {
        try {
            let id = 'remove' + i;
            const idd = ref.current;
            setIsShown(true);
        } catch (e) {
            throw e;
        }
    };
    let handleLeavebutton = () => {
        try {
            setIsShown(false);
        } catch (e) {
            throw e;
        }
    };
    /**
     * PS_MH_41 - Based on the condition the id gets inserted to the BE.
     */
    let saveClick = async () => {
        try {
            //debugger;
            const newData = [];
            screeningRound.forEach((obj) => {
                if (obj.value == "") {


                    switch (obj.label) {
                        case 'Preliminary':
                            newData.push(1);
                            break;
                        case 'Aptitude Test':
                            newData.push(2);
                            break;
                        case 'Technical':
                            newData.push(3);
                            break;
                        case 'Coding Challenge':
                            newData.push(4);
                            break;
                    }
                }
            });
            const requestPayload = {
                newRound: newRound,
                newData: newData,
                jobId: params.id
            }
            if (newData.length > 0 || !newRound.every((val) => val?.id)) {

                const response = await addInterviewRound(requestPayload);
                //debugger;

                // interview_round_name, stage_id, job_id
                if (response.data.statusCode == 200 && response.data.data.length > 0) {
                    let data = newRound;
                    for (let index = 0; index < response.data.data.length; index++) {
                        const element = response.data.data[index];
                        data['round_id'] = element.id;
                        const responseData = await insertInterviewRound(data);
                    }

                }
                getCustomRounds();
            }

        } catch (e) {
            throw e;
        }
    };

    let handleInputChange = (e, i) => {
        try {
            let value;
            if (Array.isArray(e)) {
                // This is when an option is selected
                value = e[0]?.interview_round_name || '';
            } else {
                // This is when the input is being typed into
                value = e.target ? e.target.value : e; // Handle the input event
            }
   
            // Create a copy of the current state
            let arr = [...newRound];
   
            // Update the specific interview round name
            arr[i]['interview_round_name'] = value;
   
            // Update the state
            setNewRound(arr);
            setFlag(!flag); // Toggle flag
        } catch (error) {
            console.error(error);
        }
    };

    const options = [
        { id: 1, interview_round_name: 'Group Discussion' },
        { id: 2, interview_round_name: 'Technical Discussion' },
        { id: 3, interview_round_name: 'Avasoft Final Round' },
        { id: 4, interview_round_name: 'HR Discussion' },
        { id: 5, interview_round_name: 'Avasoft Final Meeting' },
    ];
    const submit = (e, i) => {
        try {
            if (e.keyCode === 13) {
                let arr = newRound;
                arr[i]['interview_round_name'] = e.target.value;
                setNewRound(arr);
                setFlag(!flag);
            }
        } catch (err) {
            throw err;
        }
    };
    const submit1 = (e, i) => {
        try {
            let arr = newRound;
            arr[i]['interview_round_name'] = e.target.value;
            setNewRound(arr);
            setFlag(!flag);
        } catch (err) {
            throw err;
        }
    };

    let removeRound = (i, id) => {

        try {
            if (id == undefined) {
                let arr = [...newRound];
                arr.splice(i, 1);
                setNewRound(arr);
            }
            else {
                let data = { id: id };
                deleteInterview(data).then((res) => {
                    if (res.data.statusCode == 200) {
                        let arr = newRound;
                        let removed = arr.splice(i, 1);

                        setNewRound(arr);
                        setFlag(!flag);
                        //window.location.reload();
                    }
                });
            }
        } catch (e) {
            throw e;
        }
    };
    let handleCheck = (e, i) => {
        try {
            let Assessment = selectedAssesment;
            if (e == true) {
                Assessment.push(i);
            } else {
                Assessment.splice(Assessment.indexOf(i), 1);
            }
            setSelectedAssesment(Assessment);
        } catch (e) {
            throw e;
        }
    };
    /**
     * PS_MH_10 - PS_MH_13
     * This fucntion adds a new coulumn to the screening round details
     */
    const addScreeningRound = async () => {
        //debugger;
        setScreeningRound((prevRounds) => [...prevRounds, { label: '', id: '' }]);
    };
    /**
     * PS_MH_15 - PS_MH_15
     * This fucntion to remove the screening rounds from the form.
     * The records gets deleted from the BE onclick of the remove icon.
     * Delete screening fucntion is called to remove the data.
     */
    const removeScreeningRound = async (i, id) => {
        //debugger;
        if (id === undefined || id === "") {
            let arr = [...screeningRound];
            arr.splice(i, 1);
            const arr1 = arr.flat()
            setScreeningRound(arr1);
        } else {
            const data = id;
            const result = await deleteScreening(data);
            if (result.data.statusCode == 200) {
                let arr = [...screeningRound];
                arr.splice(i, 1);
                setScreeningRound(arr);
            }
        }
    };
    /**
     * PS_MH_35 - PS_MH_39
     * The change in the input field will be handled in here.
     */
    const handleSelectChange = (index, selected) => {
        //debugger
        let updateField = [...screeningRound];
        updateField[index] = { label: selected[0], value: '' };
        setScreeningRound(updateField);
    };

    return (
        <div>
            <div
                className="offcanvas offcanvas-end recruit-offcanvas"
                tabIndex={-1}
                id="offcanvasRight"
                aria-labelledby="offcanvasRightLabel"
            >
                <div className="offcanvas-header">
                    <h5 id="offcanvasRightLabel" className="bold-text font-18">
                        Customize Hiring Process
                    </h5>
                    <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close" />
                </div>
                <div className="offcanvas-body">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card customize-hiring-bg border-0">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-6 font-16 hiring-stage-title bold-text">Stages</div>
                                        <div className="col-md-6 font-16 hiring-stage-title bold-text">Assessment Type</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="card border-0">
                                <div className="card-body p-4">
                                    <h2 className="bold-text font-18">Sourcing</h2>
                                    <ul className="list-unstyled hiring-source">
                                        <li className="hiring-stages">
                                            <span className="semibold-text font-14 hiring-source-black">Open -</span>
                                            <span className="semibold-text font-14 hiring-source-grey">default</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* <div className="row">
                        <div className="col-md-6">
                            <div className="card border-0">
                                <div className="card-body p-4">
                                    <h2 className="bold-text font-18">Screening</h2>
                                    <ul className="list-unstyled hiring-screening">
                                        {expques !== 'Fresher' ? (
                                            <>
                                                <li className="hiring-stages mb-3">
                                                    <span className="semibold-text font-14 semibold-text hiring-source-black">
                                                        General Questionnaire
                                                    </span>
                                                </li>
                                                <li className="hiring-stages mb-3">
                                                    <span className="semibold-text font-14 hiring-source-black">Skill Check</span>
                                                </li>
                                            </>
                                        ) : (
                                            <>
                                                <li className="hiring-stages mb-3">
                                                    <span className="semibold-text font-14 semibold-text hiring-source-black">
                                                        Preliminary
                                                    </span>
                                                </li>
                                                {/* <li className="hiring-stages mb-3">
                                                    <span className="semibold-text font-14 hiring-source-black">Aptitude Test</span>
                                                </li>
                                                <li className="hiring-stages mb-3">
                                                    <span className="semibold-text font-14 hiring-source-black">Technical Skill Test</span>
                                                </li>
                                                <li className="hiring-stages mb-3">
                                                    <span className="semibold-text font-14 hiring-source-black">Coding Challenge</span>
                                                </li> */}
                    {/* </> */}
                    {/* )} */}
                    {/* {preliminary && (
                                            <li className="hiring-stages bg-white hiring-spacing">
                                                <span className="semibold-text font-14 hiring-source-black">Preliminary</span>
                                                <span className="cursor-pointer">
                                                    <img
                                                        src="/Images/hiring-stage-remove.svg"
                                                        alt="Hiring Stage Remove"
                                                        onClick={() => {
                                                            setPreliminary(false);
                                                        }}
                                                    />
                                                </span>
                                            </li>
                                        )} */}
                    {/* </ul>
                                </div>
                            </div>
                        </div>
                    // </div> */}
                    {/* 
                    <div className="row">
                        <div className="col-md-6">
                            <div className="card border-0">
                                <div className="card-body p-4">
                                    <div className="hiring-sub-title hiring-spacing">
                                        <h2 className="bold-text font-18">Screening</h2>
                                        <img
                                            src="/Images/hiring-add-assessment.svg"
                                            className="hiring-plus-icon"
                                            alt="Add icon"
                                            onClick={addScreeningRound}
                                        />
                                    </div>
                                    <ul className="list-unstyled hiring-screening">
                                         
                                    <li className="hiring-stages ">
                                            <span className="semibold-text font-14 hiring-source-black">Preliminary -</span>
                                            <span className="semibold-text font-14 hiring-source-grey">default</span>
                                        </li>

                                        {screeningRound.map((round, index) => (
                                            <li key={index} className="hiring-stages mb-3 bg-white hiring-spacing" onMouseEnter={() => setIsHover(true)}
                                                onMouseLeave={() => setIsHover(false)}>
                                                <Typeahead
                                                    id={index}
                                                    onChange={(selected) => handleSelectChange(index, selected)}
                                                    options={screeningOptions.filter((option) => option !== 'Preliminary')}
                                                    defaultSelected={round.label ? [{ label: round.label, value: round.id }] : []}
                                                    placeholder="Select Screening Rounds"
                                                    className="semibold-text font-10 hiring-source-black"
                                                    style={{
                                                        'border-style': 'none',
                                                        outline: 'none',
                                                    }}
                                                />
                                                {isHover ? (<span className="cursor-pointer">
                                                    <img
                                                        src="/Images/hiring-stage-remove.svg"
                                                        alt="Hiring Stage Remove"
                                                        onClick={() => removeScreeningRound(index, round.id)}
                                                    />
                                                </span>) : null}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div> */}

                    <div className="row">
                        <div className="col-md-6">
                            <div className="card border-0">
                                <div className="card-body p-4">
                                    <div className="hiring-sub-title hiring-spacing">
                                        <h2 className="bold-text font-18">Screening</h2>
                                        <img
                                            src="/Images/hiring-add-assessment.svg"
                                            className="hiring-plus-icon"
                                            alt="Add icon"
                                            onClick={addScreeningRound}
                                        />
                                    </div>

                                    <ul className="list-unstyled hiring-screening">

                                        <li className="hiring-stages mb-3 bg-white hiring-spacing">
                                            <span className="semibold-text font-14 hiring-source-black">Preliminary </span>
                                            <span className="semibold-text font-14 hiring-source-grey">default</span>
                                        </li>
                                        {screeningRound.map((round, index) => (

                                            <li key={index} className="hiring-stages mb-3 bg-white hiring-spacing" onMouseEnter={() => setIsHover(true)}
                                                onMouseLeave={() => setIsHover(false)}>

                                                {round.id ? (
                                                    <input
                                                        type="text"
                                                        value={round.label}
                                                        style={{
                                                            'border-style': 'none',
                                                            outline: 'none',
                                                        }}
                                                        disabled={true}
                                                        className="semibold-text font-14 hiring-source-black" />
                                                ) : (
                                                    <Typeahead
                                                        id={index}
                                                        labelKey="label"
                                                        selected={round?.label ? [round?.label] : []}
                                                        onChange={(selected) => handleSelectChange(index, selected)}
                                                        //   onInputChange={(inputValue) => handleInputChange(inputValue, index)}
                                                        // defaultSelected={round.label ? [{ label: round.label, value: round.id }] : []}
                                                        onKeyDown={(e) => submit(e, index)}
                                                        options={screeningOptions.filter((option) => option !== 'Preliminary')}
                                                        placeholder="Select Screening Rounds"
                                                        className="semibold-text font-8 hiring-source-black"
                                                        style={{
                                                            'border-style': 'none',
                                                            outline: 'none',
                                                        }}
                                                    />
                                                )}

                                                {isHover ? (
                                                    <span className="cursor-pointer">
                                                        <img
                                                            src="/Images/hiring-stage-remove.svg"
                                                            alt="Hiring Stage Remove"
                                                            onClick={() => removeScreeningRound(index, round.id)}
                                                        />
                                                    </span>
                                                ) : null}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div className="row">
                        <div className="col-md-12">
                            <div className="card border-0">
                                <div className="card-body p-4">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="hiring-sub-title hiring-spacing">
                                                <h2 className="bold-text font-18">Interviews</h2>
                                                <img
                                                    src="/Images/hiring-add-assessment.svg"
                                                    className="hiring-plus-icon"
                                                    alt="Add icon"
                                                    onClick={() => {
                                                        addRound();
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    {newRound.map((obj, i) => {
                                        return (
                                            <>
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <ul className="list-unstyled hiring-interviews mb-0 pb-3">
                                                            <li
                                                                className="hiring-stages bg-white hiring-spacing"
                                                                onMouseEnter={() => handleEnterbutton(i)}
                                                                onMouseLeave={() => handleLeavebutton(i)}
                                                            >
                                                                {obj.id !== undefined ? (
                                                                    <input
                                                                        type="text"
                                                                        value={obj.interview_round_name}
                                                                        // onChange={(e) => handleInputChange(e, i)}
                                                                        style={{
                                                                            'border-style': 'none',
                                                                            outline: 'none',
                                                                        }}
                                                                        disabled={obj.id !== undefined ? true : false}
                                                                        className="semibold-text font-14 hiring-source-black"
                                                                    />
                                                                ) : (
                                                                    <Typeahead
                                                                        id="basic-typeahead-single"
                                                                        labelKey="interview_round_name"
                                                                        selected={obj.interview_round_name ? [obj.interview_round_name] : []}
                                                                        onChange={(value) => handleInputChange(value, i)}
                                                                        onInputChange={(event) => handleInputChange(event, i)}
                                                                        onKeyDown={(e) => {
                                                                            submit(e, i);
                                                                        }}
                                                                        className="semibold-text font-14 hiring-source-black"
                                                                        options={options}
                                                                        placeholder="Select Interview Rounds"
                                                                        style={{
                                                                            'border-style': 'none',
                                                                            outline: 'none',
                                                                        }}
                                                                    />
                                                                )}

                                                                {isShown ? (
                                                                    <span className="cursor-pointer" id={`remove${i}`}>
                                                                        <img
                                                                            src="/Images/hiring-stage-remove.svg"
                                                                            alt="Hiring Stage Remove"
                                                                            onClick={() => {
                                                                                removeRound(i, obj.id);
                                                                            }}
                                                                        />
                                                                    </span>
                                                                ) : null}
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="dropdown">
                                                            <button
                                                                className="btn font-14 dropdown-toggle medium-text"
                                                                id={'hiringprocess-dropdown1'}
                                                                data-bs-toggle="dropdown"
                                                                data-bs-display="static"
                                                                aria-expanded="true"
                                                            >
                                                                <img
                                                                    src="/Images/hiring-configure.svg"
                                                                    className="me-2"
                                                                    alt="Hiring Configuration Icon"
                                                                />
                                                                Configure{' '}
                                                            </button>
                                                            <div
                                                                className="dropdown-menu p-3 hiring-check-dropdown shadow border-0"
                                                                aria-labelledby={'hiringprocess-dropdown1'}
                                                            >
                                                                <h2 className="hiring-configure-title semibold-text font-16">
                                                                    Choose Assessment Type{' '}
                                                                </h2>
                                                                <ul className="list-group border-bottom pb-3">
                                                                    <li className="list-group-item border-0 ps-0">
                                                                        <input
                                                                            className="form-check-input hive-form-check-input me-1"
                                                                            type="checkbox"
                                                                            defaultValue
                                                                            id="hiring-attitude"
                                                                            onChange={(e) => handleCheck(e.target.checked, 1)}
                                                                        />
                                                                        <label
                                                                            className="assement-type-stl font-13 semibold-text"
                                                                            htmlFor="hiring-attitude"
                                                                        >
                                                                            Attitude
                                                                        </label>
                                                                    </li>
                                                                    <li className="list-group-item border-0 ps-0">
                                                                        <input
                                                                            className="form-check-input hive-form-check-input me-1"
                                                                            type="checkbox"
                                                                            defaultValue
                                                                            id="hiring-communication"
                                                                            onChange={(e) => {
                                                                                handleCheck(e.target.checked, 2);
                                                                            }}
                                                                        />
                                                                        <label
                                                                            className="assement-type-stl font-13 semibold-text"
                                                                            htmlFor="hiring-communication"
                                                                        >
                                                                            Communication
                                                                        </label>
                                                                    </li>
                                                                    <li className="list-group-item border-0 ps-0">
                                                                        <input
                                                                            className="form-check-input hive-form-check-input me-1"
                                                                            type="checkbox"
                                                                            defaultValue
                                                                            id="hiring-business"
                                                                            onChange={(e) => {
                                                                                handleCheck(e.target.checked, 3);
                                                                            }}
                                                                        />
                                                                        <label
                                                                            className="assement-type-stl font-13 semibold-text"
                                                                            htmlFor="hiring-business"
                                                                        >
                                                                            Business
                                                                        </label>
                                                                    </li>
                                                                    <li className="list-group-item border-0 ps-0">
                                                                        <input
                                                                            className="form-check-input hive-form-check-input me-1"
                                                                            type="checkbox"
                                                                            defaultValue
                                                                            id="hiring-technology"
                                                                            onChange={(e) => {
                                                                                handleCheck(e.target.checked, 4);
                                                                            }}
                                                                        />
                                                                        <label
                                                                            className="assement-type-stl font-13 semibold-text"
                                                                            htmlFor="hiring-technology"
                                                                        >
                                                                            Technology
                                                                        </label>
                                                                    </li>
                                                                </ul>

                                                                <div className="d-flex justify-content-end m-3">
                                                                    <button className="btn hive-btn-secondary me-3">Cancel</button>
                                                                    <button
                                                                        className="btn hive-btn-primary"
                                                                        onClick={() => {
                                                                            saveAssessment(i, obj.id);
                                                                        }}
                                                                    >
                                                                        Save
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="card border-0">
                                <div className="card-body p-4">
                                    <h2 className="bold-text font-18">Offer</h2>
                                    <ul className="list-unstyled hiring-offer">
                                        <li className="hiring-stages mb-3">
                                            <span className="font-14 semibold-text hiring-source-black">Offer Draft -</span>
                                            <span className="font-14 semibold-text hiring-source-grey">Default</span>
                                        </li>
                                        <li className="hiring-stages mb-3">
                                            <span className="font-14 semibold-text hiring-source-black">Offered -</span>
                                            <span className="font-14 semibold-text hiring-source-grey">Default</span>
                                        </li>
                                        <li className="hiring-stages mb-3">
                                            <span className="font-14 semibold-text hiring-source-black">Offer Accepted -</span>
                                            <span className="font-14 semibold-text hiring-source-grey">Default</span>
                                        </li>
                                        <li className="hiring-stages mb-3">
                                            <span className="font-14 semibold-text hiring-source-black">Offer Declined -</span>
                                            <span className="font-14 semibold-text hiring-source-grey">Default</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="card border-0">
                                <div className="card-body p-4">
                                    <h2 className="bold-text font-18">Hire</h2>
                                    <ul className="list-unstyled hiring-hire">
                                        <li className="hiring-stages mb-3">
                                            <span className="semibold-text font-14 hiring-source-black">Hired -</span>
                                            <span className="semibold-text font-14 hiring-source-grey">Default</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="d-flex justify-content-end m-3">
                                <button className="btn hive-btn-secondary me-3" data-bs-dismiss="offcanvas" aria-label="Close">
                                    Cancel
                                </button>
                                <button
                                    className="btn hive-btn-primary"
                                    data-bs-dismiss="offcanvas"
                                    aria-label="Close"
                                    onClick={() => {
                                        saveClick();
                                    }}
                                >
                                    Save
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default CustomHiringProcess;
